import Link from 'next/link';
import clsx from 'clsx';
import { useTranslation, Trans } from 'next-i18next';

import { Container } from '@ui/Container';

export const CatalogBanner = () => {
  const { t: tt } = useTranslation('characters_catalog');

  return (
    <Container
      as="section"
      className={clsx(
        'flex flex-row justify-start items-start',
        'py-[10px] md:py-[75px]',
        'rounded-[12px]',
        'bg-wtf-evening/60',
        // Background classes with responsive design
        'bg-mobile-banner sm:bg-desktop-banner',
        'bg-cover bg-center', // Ensuring cover and center are applied across all sizes
        'h-[284px] md:h-auto', // Setting minimum height for mobile and auto height for larger screens
      )}
    >
      <div
        className={clsx(
          'w-full md:max-w-[450px]',
          'h-full md:h-auto',
          'flex flex-col justify-between md:justify-start items-center md:items-start',
        )}
      >
        <div className="w-full mb-[24px]">
          <h1
            className={clsx(
              'max-w-[190px] md:max-w-full',
              'text-[24px] sm:text-[32px] leading-tight font-semibold text-wtf-white',
              'my-0 mb-[20px]',
            )}
          >
            {tt('banner.title')}
          </h1>

          <div
            className={clsx(
              'hidden md:!block', // This helps to override css conflicts with globals
            )}
          >
            <Trans t={tt} i18nKey="banner.text">
              <p
                className={clsx(
                  'my-0 mb-[16px]',
                  'text-[16px] leading-normal text-wtf-white',
                )}
              >
                Design your dream AI girlfriend: every detail, from her spicy
                looks to her captivating personality, is tailored by you.
              </p>
              <p
                className={clsx(
                  'my-0',
                  'text-[16px] leading-normal text-wtf-white',
                )}
              >
                Perfect girl, born from your desires...
              </p>
            </Trans>
          </div>
        </div>

        <Link
          className={clsx(
            'py-[8px] px-[16px]',
            'rounded-[8px]',
            'md:px-[32px]',
            'md:py-[12px]',
            'bg-wtf-persianRed',
            'text-[16px] leading-none font-semibold text-wtf-white',
            'transform transition',
            'focus:scale-105 focus:brightness-125',
            'hover:scale-105 hover:brightness-125',
          )}
          href="/create-your-ai-girlfriend"
        >
          {tt('banner.create')}
        </Link>
      </div>
    </Container>
  );
};
